import { TranslatorService } from '@services/translator/translator.service';
import { Locale } from '@shared/models/signrequest/sign.signatory';
import { ConfigService } from '@services/config/config.service';
import { ErrorDisplayService } from '@services/error-display/error-display.service';
import {DOCUMENT, inject} from '@angular/core';
import {catchError, tap} from 'rxjs/operators';
import {throwError} from 'rxjs';

function getAccountName(location: Location): string {

    const pathnames = location.pathname.split('/').filter(path => path);

    if ((location.hostname === 'localhost'
        || location.hostname === 'testzyn'
        || location.hostname === 'testzyn.zoetermeer.nl'
        || location.hostname === 'ztmzyn.zoetermeer.nl'
        || location.hostname === 'start.zynyo.com')
        && pathnames.length) {
        // Returns first part after host start.zynyo.com/account-name
        console.log(pathnames[0]);
        return pathnames[0];
    } else {
        // Returns first part of the host account-name.zynyo.com
        const subdomain = location.hostname.split('.dtm.zynyo.com').find(path => path);

        return subdomain ?? 'kubernetes';

    }
}

export function initializeApp() {
    const configService = inject(ConfigService);
    const document = inject(DOCUMENT);
    const translatorService = inject(TranslatorService);
    const errorDisplayService = inject(ErrorDisplayService);

    const account = getAccountName(document.location);
    console.log(`Found account '${account}'`);

    return configService.fetchConfig(account).pipe(
        // Set language once config is loaded
        tap(() => translatorService.setLanguage({ code: Locale.NL, text: 'Nederland' })),
        catchError(error => {
            errorDisplayService.displayError('De server is niet beschikbaar', error.message);
            return throwError(() => error);
        })
    );
}
